import { Agency } from './../models/agency.model';
import { Property } from './../models/property.model';
import { Component, Input, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-house-details-sd',
  template: `
    <app-json-ld [json]="schemaProperty"></app-json-ld>
    <app-json-ld [json]="schemaBreadcrumbs"></app-json-ld>
  `
})
export class HouseDetailsSdComponent implements OnInit {
  @Input() property: Property;
  @Input() agency: Agency;
  @Input() breadcrumbs: any;
  public schemaProperty: any;
  public schemaBreadcrumbs: any = {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': []
  };

  constructor(
    @Inject(DOCUMENT) private document: any
  ) { }

  ngOnInit(): void {

    if (this.breadcrumbs && this.breadcrumbs.length > 0) {
      let i = 1;

      this.breadcrumbs.forEach(breadcrum => {

        let link = this.document.location.origin;

        if (breadcrum.routerLink && breadcrum.routerLink.length > 0) {
          breadcrum.routerLink.forEach(breadcrumSlice =>
            link += breadcrumSlice
          );
        }

        this.schemaBreadcrumbs['itemListElement'].push({
          '@type': 'ListItem',
          'position': i,
          'item': {
            '@id': link,
            'name': breadcrum.name
          }
        });

        i++;
      });
    } else {
      throw new Error('HouseDetailsSdComponent structured data error: Invalid breadcrumbs');
    }

    if (this.agency && this.property) {

      this.schemaProperty = {
        '@context': 'http://schema.org',
        '@type': 'Product',
        'additionalType': 'http://www.productontology.org/id/Condominium',
        'name': this.property.title,
        'description': this.property.description,
        'offers': {
          '@type': 'Offer',
          'priceCurrency': this.property.currency_id,
          'price': this.property.sale_price,
          'availability': this.property.availability === 'available' ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock',
          'seller': {
            '@type': 'RealEstateAgent',
            'name': this.agency.name,
            'telephone': this.agency.phone,
            'email': this.agency.email,
            'address': {
              '@type': 'PostalAddress',
              'addressLocality': this.agency.city_name,
              'streetAddress': this.agency.address
            },
            'geo': {
              '@type': 'GeoCoordinates',
              'latitude': this.agency.latitude,
              'longitude': this.agency.longitude
            }
          }
        },
        'brand': {
          '@type': 'Brand',
          'name': this.agency.name
        }
      };

      if (this.property.images && this.property.images.length > 0) {
        this.schemaProperty['image'] = this.property.images[0].url;
      }

      if (this.agency.logo) {
        this.schemaProperty['offers']['seller']['image'] = this.agency.logo.url;
        this.schemaProperty['brand']['logo'] = this.agency.logo.url;
      }

    } else {
      if (this.agency) {
        throw new Error('HouseDetailsSdComponent structured data error: Invalid property');

      } else if (this.property) {
        throw new Error('HouseDetailsSdComponent structured data error: Invalid agency');

      } else {
        throw new Error('HouseDetailsSdComponent structured data error: Invalid property and agency');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/seo/house-details-sd.component.ts